import React, { useEffect, useRef, useState } from 'react'
import { Box, Card, CircularProgress, Skeleton, Typography } from '@mui/material'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Colors } from '../../../../Styles/Colors'
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService'
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents'
import { Doctor_Notes_Layout_Json } from '../../../../Utility/Constants'
import "../../../FrontOffice/OutPatients/PatientDetails/patientDetails.css"
import DocPastPresentComplaints from './DocPastPresentComplaints'
import DocExpectedOutcome from './DocExpectedOutcome'
import DocNewPresentComplaints from './DocNewPresentComplaint'
import DocSystemicExamination from './DocSystemicExamination'
import DocAyurvedicDiagnosis from './DocAyurvedicDiagnosis'
import DocAllopathicDiagnosis from './DocAllopaticDiagnosis'
import DocCurrentAllopathicMedication from './DocAllopathicMedication'
import DocGeneralAdvice from './DocGeneralAdvise'
import DocPatientCategories from './DocPatientCategories'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import DocLastVisitRecords from './DocLastVisitRecords'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import DocInvestigations from './DocInvestigations'
import DocTreatmentPlan from './DocTreatmentPlan'
import DocPrescription from './DocPrescription'
import DocIcdDiagnosis from './DocIcdDiagnosis'
import DocPainScale from './DocPainScale'
import DietPlan from './DocDietPlan'
import DocTentativePlan from './DocTentativePlan'
import DocVitals from './DocVitals'
import DocCarePlan from './DocCarePlan'

const DoctorNotes = (props) => {

    const [state, setState] = useState({
        loginInfo: JSON.parse(localGetItem('loggedInUserInfo')),
        clinicId: localGetItem('SelectedDoctorClinicId'),
        PatientData:  props.is_From_IpNotes ? JSON.parse(getCachevalue("IppatientData")) : JSON.parse(getCachevalue("DoctorPatientData")),
        DocNotesLayout: [],
        SelectedComponent: null,
        layoutloading: false,
        scrollToIndex: null,
        lastVisitRecords: {},
        isLocked: false,
        isFromIpNotes: props?.is_From_IpNotes || false
    })

    const divRefs = useRef([]);
    const functionRegistry = useRef({});

    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    useEffect(() => {
        if (state.loginInfo) {
            getDoctorNotesLayout()
            getLastVisitRecords()
        }
    }, [state.loginInfo])

    useEffect(() => {
        if (state.DocNotesLayout.length) {
            const newRefs = [];
            let activeIndex = 0;

            for (let i = 0; i < state.DocNotesLayout.length; i++) {
                if (state.DocNotesLayout[i].is_active) {
                    newRefs[activeIndex] = divRefs.current[activeIndex] ?? React.createRef();
                    activeIndex++;
                }
            }

            divRefs.current = newRefs;
        }
    }, [state.DocNotesLayout]);

    useEffect(() => {
        if (!state.layoutloading && state.DocNotesLayout.length > 0) {
            // Find first active item index
            const firstActiveIndex = state.DocNotesLayout.findIndex(item => item.is_active);
            setState(prev => ({
                ...prev,
                scrollToIndex: firstActiveIndex === -1 ? null : 0, // 0 for first active item in refs
                SelectedComponent: state.DocNotesLayout[firstActiveIndex]?.field_name,
            }));
        }
    }, [state.layoutloading, state.DocNotesLayout]);

    useEffect(() => {
        if (
            state.scrollToIndex !== null &&
            !state.layoutloading &&
            divRefs.current[state.scrollToIndex]?.current
        ) {
            requestAnimationFrame(() => {
                divRefs?.current[state.scrollToIndex]?.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'center',
                });
            });
        }
    }, [state.scrollToIndex, state.layoutloading, state.DocNotesLayout]);

    const registerRefreshFunction = (key, fn) => {
        functionRegistry.current[key] = fn;
    };

    const triggerRefresh = (fieldName) => {
        const fn = functionRegistry.current[fieldName];
        if (typeof fn === "function") {
            fn();   // Calls child's get function
        }
    };

    const errorMessage = (msg) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: msg,
        })
    }

    const successMessage = (msg) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: msg,
        })
    }

    const msgClose = () => {
        setMessage({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    // API Starts

    const getDoctorNotesLayout = () => {
        try {
            updateState({ layoutloading: true })
            const Doctor_Notes_Layout = JSON.parse(JSON.stringify(Doctor_Notes_Layout_Json));
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_LAYOUT)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const { field_data } = response.data.data;
                        const { layout_data } = field_data;
                        const layoutData = layout_data ? layout_data : Doctor_Notes_Layout
                        updateState({
                            DocNotesLayout: layoutData,
                            SelectedComponent: layoutData[0]?.field_name,
                            isNewLayout: layoutData[0]?.is_new ? layoutData[0] : {},
                            layoutloading: false,
                        })
                    }
                }).catch((error) => {
                    updateState({ layoutloading: false })
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ layoutloading: false })
            errorMessage(error.message)
        }
    }

    const getLastVisitRecords = () => {
        try {
            updateState({ visitLoading: true })
            const isFromIp = state.isFromIpNotes
            const q = isFromIp
                ? `ip_admission_id=${state.PatientData?.id}&patient_id=${state.PatientData?.patient_id}&clinic_id=${state.clinicId}&doctor_id=${state.PatientData?.doctor_id}`
                : `appointment_id=${state.PatientData?.appointment_id}&patient_id=${state.PatientData?.patient_id}`
            RestAPIService.getAll(Serviceurls.AYURVEDA_LAST_VISIT_RECORDS + '?' + q)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        updateState({
                            lastVisitRecords: response.data.data,
                            visitLoading: false,
                        })
                    }
                }).catch((error) => {
                    updateState({ visitLoading: false })
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ visitLoading: false })
            errorMessage(error.message)
        }
    }

    // Functionalities start
    const renderComponent = (data) => {
        const { field_name, custom_name } = data;
        const commonProps = {
            Title: custom_name,
            field_name,
            PatientData: state.PatientData,
            patientId: state.PatientData?.patient_id,
            appointmentId: state.PatientData?.appointment_id,
            isSelected: field_name === state.SelectedComponent,
            isLocked: state.isLocked,
            // isCompleted: PatientData?.appointment_status === "Completed",
            isFromIp: state?.isFromIpNotes,
            ipAdmissionId: state.PatientData?.id,
            doctorId: state.PatientData?.doctor_id,
            errorMessage: errorMessage.bind(this),
            successMessage: successMessage.bind(this),
            clinicId: state.clinicId,
            // Child will register its GET function here
            registerRefreshFunction: registerRefreshFunction,
        };

        switch (field_name) {
            case "patient_categories":
                return <DocPatientCategories {...commonProps} />;
            case "diagnosis":
                return <DocIcdDiagnosis {...commonProps} />;
            case "past_presenting_complaints":
                return <DocPastPresentComplaints {...commonProps} />;
            case "expected_outcome":
                return <DocExpectedOutcome {...commonProps} />;
            case "new_presenting_complaints":
                return <DocNewPresentComplaints {...commonProps} />
            case "systemic_examination":
                return <DocSystemicExamination {...commonProps} />
            case "pain_scale":
                return <DocPainScale {...commonProps} />;
            case "ayurvedic_diagnosis":
                return <DocAyurvedicDiagnosis {...commonProps} />
            case "allopathic_diagnosis":
                return <DocAllopathicDiagnosis {...commonProps} />
            case "current_allopathic_medication":
                return <DocCurrentAllopathicMedication {...commonProps} />
            case "treatment_plan":
                return <DocTreatmentPlan {...commonProps} />
            case "investigation":
                return <DocInvestigations {...commonProps} />
            case "general_advice":
                return <DocGeneralAdvice {...commonProps} />
            case "prescription":
                return <DocPrescription {...commonProps} />
            case "diet_plan":
                return <DietPlan {...commonProps} />
            case ("tentative_plan") :
                if( state?.isFromIpNotes === false){
                return <DocTentativePlan {...commonProps} />
                }
                break
            case "vitals":
                return <DocVitals {...commonProps} />
            case "care_plan":
                return <DocCarePlan {...commonProps} />
            default:
                return null;
        }
    }

    const renderVisitRecords = () => {
        return (
            <Box width="100%" height="100%">
                <Typography fontSize={"0.85vw"} fontWeight={"bold"} padding={"0.5dvw"} borderBottom={`1px solid #E3E2E2`} color={Colors.SecondaryText}>Last Visit Records</Typography>
                {(state.layoutloading || state.visitLoading) ? (
                    <Box sx={{ width: "100%", height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress color="primary" size={"1vw"} />
                    </Box>
                ) :

                    (Object.keys(state.lastVisitRecords)?.length > 0 ?
                        state.DocNotesLayout?.map((item, index) => {
                            if (!item.is_active) return null;
                            const fieldKey = item.field_name?.toLowerCase();
                            const value = state.lastVisitRecords[fieldKey];
                            if (fieldKey === "patient_categories") return null;
                            if (!value || (Array.isArray(value) && value.length === 0)) return null;

                            return (
                                <DocLastVisitRecords
                                    key={index}
                                    field_name={item.field_name}
                                    label={item.custom_name}
                                    value={value}
                                    appointmentId={state.PatientData?.appointment_id}
                                    old_appointmrntId={state.lastVisitRecords.appointment_id}
                                    isFromIp={state.isFromIpNotes}
                                    ipAdmissionId={state.PatientData?.id}
                                    clinicId={state.clinicId}
                                    doctorId={state.PatientData?.doctor_id}
                                    errorMsgFunc={errorMessage.bind(this)}
                                    successMsgFunc={successMessage.bind(this)}
                                    triggerRefresh={triggerRefresh.bind(this)}
                                />
                            );

                        }) : renderNOData())}
            </Box>
        )
    }
    const renderNOData = () => {
        return (<Box className="eMed_noDataDiv">
            <p id="eMed_revenueCard_Txt">No Records Found</p>
        </Box>)
    }

    return (
        <Box sx={{ backgroundColor: Colors.ComponentBgColor, height: "100%", padding: "0.6dvw" }}>
            <Box display={'flex'} alignItems='center'>
                <Box className='eMed_Patient_Details_Long eMed_patient_box'>
                    <CommonPatientDetails data={state.PatientData} showDetailed={true} fromDoctor={true} hideInsurance={true} />
                </Box>
            </Box>
            <Box display={'flex'} alignItems='center'>
                <Box className="emed_grid_column" sx={{ height: "65dvh", overflow: "auto", padding: "0px", width: "75%", border: state.layoutloading ? "1px solid #ccc" : " none" }}>
                    {state.layoutloading ? (
                        <Box>
                            {[25, 25, 10].map((h, i) => (
                                <Skeleton
                                    key={i}
                                    variant="rounded"
                                    animation="wave"
                                    width="97%"
                                    height={`${h}vh`}
                                    sx={{ margin: '1vw' }}
                                />
                            ))}
                        </Box>
                    ) : (
                        state.DocNotesLayout?.length > 0 ?
                            state?.DocNotesLayout?.reduce((acc, item, index) => {
                                if (!item.is_active) return acc;
                                const activeIndex = acc.length; // the number of active items so far

                                acc.push(
                                    <Box
                                        style={{ margin: "0.8dvw" }}
                                        key={item.id || index}
                                        ref={divRefs.current[activeIndex]}
                                        onClick={() =>
                                            updateState({
                                                SelectedComponent: item.field_name,
                                                isNewLayout: item?.is_new ? item : {},
                                            })
                                        }
                                    >
                                        {renderComponent(item)}
                                    </Box>
                                );
                                return acc;
                            }, []) : renderNOData()
                    )}
                </Box>
                <Card sx={{ overflowY: 'auto', padding: '0.625dvw', height: "66dvh", width: "25%" }}>{renderVisitRecords()}</Card>
            </Box>
            {message.isErrorMsg && <ToastMsg severity={"error"} msg={message.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {message.successMsg && <ToastMsg severity={"success"} msg={message.successMsgText} msgPop={msgClose.bind(this)} />}
        </Box>

    )
}

export default DoctorNotes